import React from 'react';
import { toast } from 'react-toastify';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Modal from 'new/components/Modal';
import Button from 'new/components/Button/Button';
import useConfetti from 'new/hooks/useConfetti';
import { useGetUserFromToken } from 'new/modules/MembershipPlan/hooks';
import { useGoLiveSingle } from '../hooks';

type Props = {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
};

const StyledTypography = styled(Typography)({
  width: 350,
  margin: '20px 0 40px',
  fontWeight: 'bold',
  textAlign: 'center',
});

const StyledBox = styled(Box)({
  textAlign: 'center',

  button: {
    margin: '0 8px',
  },
});

const ModalGoLive: React.FC<Props> = ({ open, onClose, refetch }) => {
  const { data: user } = useGetUserFromToken();
  const { mutate: goLiveSingle, isLoading } = useGoLiveSingle(
    user?.data.daoi.dentistInfoId,
  );
  const { startConfetti } = useConfetti();

  const onSubmit = () => {
    goLiveSingle(undefined, {
      onSuccess: () => {
        startConfetti();
        setTimeout(() => {
          refetch();
        }, 6000);
        onClose();
        toast.success('You can start enrolling members!');
      },
      onError: () => {
        toast.error('Something went wrong');
      },
    });
  };

  return (
    <Modal open={open} onClose={onClose}>
      <StyledTypography>
        If you're ready to start enrolling members,
        <br />
        turn on member enrollment below.
      </StyledTypography>
      <StyledBox>
        <Button onClick={onClose} variant="outlined">
          CANCEL
        </Button>
        <Button onClick={onSubmit} isLoading={isLoading}>
          I'm ready
        </Button>
      </StyledBox>
    </Modal>
  );
};

export default ModalGoLive;
